export class SsnRevealElement extends HTMLElement {
  disconnectController?: AbortController;

  connectedCallback() {
    this.disconnectController = new AbortController();
    this.addEventListener('click', () => this.toggle(), {
      signal: this.disconnectController.signal,
      once: true
    });
  }

  disconnectedCallback() {
    this.disconnectController?.abort();
  }

  toggle() {
    this.textContent = this.getAttribute('value') ?? '[Value missing]';
  }
}

declare global {
  interface Window {
    SsnRevealElement: typeof SsnRevealElement;
  }
  interface HTMLElementTagNameMap {
    'ssn-reveal': SsnRevealElement;
  }
}

if (!window.customElements.get('ssn-reveal')) {
  window.SsnRevealElement = SsnRevealElement;
  window.customElements.define('ssn-reveal', SsnRevealElement);
}
